import React from 'react'

import ActionSelect from './ActionSelect'

const allowedActions = ['goToStep', 'hide_no_agent_avl_action']

const TransferToDepartment = () => {
  return (
    <div className='select-action'>
      <div className='label'>What happens if no agents are available?</div>
      <ActionSelect actionGroup='no_agents_available_action' allowedActions={allowedActions} />
    </div>
  )
}

export default TransferToDepartment
